"use client";

import { useLocale, useTranslations } from "next-intl";
import { NotFoundView } from "@/components/NotFoundView";

export default function NotFound() {
  const locale = useLocale();
  const t = useTranslations("NotFound");

  return (
    <NotFoundView
      locale={locale === "es" ? "es" : "en"}
      strings={{
        title: t("title"),
        description: t("description"),
        hint: t("hint"),
        backHome: t("backHome"),
        browseTemplates: t("browseTemplates"),
      }}
    />
  );
}
